<template>
  <div class="context">
    <p class="title">API概要</p>
    <p class="item">
      データカタログサイトの情報の一部をAPIにて提供いたします。<br />
      本システムについてはオープンソースソフトウェアであるFIWAREをベースに作成されています。<br />
      利用に関しては事前に申請いただき利用いただくこととなります。<br />
      詳細は利用手順をご確認ください。
    </p>
    <div class="graph"></div>
  </div>
</template>
<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.item {
  font-size: 1.4vw;
}

.graph {
  margin-top: 8%;
  background-image: url("../../../assets/image/about-api.png");
  background-size: contain;
  width: 100%;
  aspect-ratio: 87/13;
}
</style>
